import { QuestionBase } from './question-base.model';

export class ImageAnnotationQuestion extends QuestionBase<string> {
    controlType = 'annotation';
    datasource: any;
    visible: string;
    type: any;

    constructor(options: {} = {}) {
        super(options);
        this.datasource = options['datasource'];
        this.type = options['type'] ? options['type'] : "String"
        this.visible = (options['visible'] == undefined) ? true : options['visible'];
    }
}
